<template>
  <div>
    <v-dialog
      @keydown.esc="dialog=false"
      style="z-index: 9999;"
      max-width="400"
      v-model="dialog"
      persistent>
      <v-card>
        <v-card-title>
          <div class="d-flex">
            <div class="primary--text">
              Adjuntar documento
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <v-form v-model="form.isValid" ref="form">
            <v-row>
              <v-col cols="12">
                <v-menu
                  ref="datePicker"
                  v-model="datePicker"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.data.date"
                      :rules="form.rules.required"
                      label="Fecha de facturación"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :allowed-dates="allowedDates"
                    v-model="form.data.date"
                    no-title
                    scrollable
                  >
                    <div>
                      <div class="d-flex">
                        <v-btn text color="grey" @click="datePicker = false">Cancel</v-btn>
                        <v-btn :disabled="!form.data.date" color="primary" @click="datePicker = false">OK</v-btn>
                      </div>
                    </div>
                  </v-date-picker>
                </v-menu>
                <v-file-input
                  v-model="form.data.file"
                  :rules="form.rules.required"
                  multiple
                  label="PDF file"
                  accept=".pdf"
                  required>
                </v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            rounded
            small
            depressed
            @click="close">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            class="mr-4"
            rounded
            small
            depressed
            @click="submit">
            Subir documento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="999999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: 'AttachInvoice',
  props: ['dialog', 'orders'],
  data () {
    return {
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      datePicker: false,
      overlay: false,
      payOrder: null,
      form: {
        isValid: false,
        data: {
          file: null,
          date: null,
          orderIds: []
        },
        rules: {
          required: [v => !!v || 'Required']
        }
      }
    }
  },
  methods: {
    allowedDates (val) {
      return this.$moment(val).isSameOrBefore(new Date())
    },
    async submit () {
      if (this.$refs.form.validate()) {
        this.overlay = true
        try {
          this.form.data.orderIds = this.orders.map(x => x._id)
          const result = await this.$api.post(`/v1/expenses/${this.$store.state.currentRestaurant.data._id}/attach-document`,
            this.form.data,
            { delivery: 'formData' })
          this.payOrder = result
          this.close()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    close () {
      this.$refs.form.reset()
      this.payOrder = null
      this.form.orderIds = []
      this.form.data.file = null
      this.form.data.date = null
      this.$emit('close')
    }
  }
}
</script>
